import React from 'react';
import { Columns } from "react-bulma-components";

export default function Page({ actions, children, icon, title, subtitle }) {
    return (
        <div>
            <Columns className="my-5 is-align-items-center">
                <Columns.Column className="is-size-3">
                    <div className="is-flex">
                        <div
                            className="mr-4 is-flex is-align-items-center is-justify-content-center has-background-primary has-text-white"
                            style={ { width: '4rem', height: '4rem', borderRadius: '999px' } }>
                            {
                                icon ? React.createElement(icon, {
                                    width: 32,
                                    height: 32
                                }) : null
                            }
                        </div>

                        <div className="is-flex-grow-1">
                            <h1 className="title">
                                { title }
                            </h1>
                            <p className="subtitle">
                                { subtitle }
                            </p>
                        </div>
                    </div>
                </Columns.Column>

                <Columns.Column narrow>
                    { actions }
                </Columns.Column>
            </Columns>

            { children }
        </div>
    );
}